angular.module('autoremind.reports.unsubscribe', [])
    .directive('reportUnsubscribe', ['$rootScope', 'unsubscribeService', '$location', 'eventSharingService', 'routeSelectorsDowngraded',
    function ($rootScope, unsubscribeService, $location, eventSharingService, routeSelectorsDowngraded) {
        return {
            restrict: 'EA',
            templateUrl: 'app/reports/unsubscribe/unsubscribe.html',
            scope: false,
            link: function ($scope, elem, attr) {
                $scope.userPath = '';
                $scope.userParam = '';
                $scope.init = function () {
                    routeSelectorsDowngraded.selectRoutesPath()
                        .subscribe(function (routeData) {
                        $scope.userPath = angular.copy(routeData.USER.path);
                        $scope.userParam = angular.copy(routeData.USER.param);
                    });
                };
                $scope.init();
                $scope.unsubscribeService = unsubscribeService;
                $scope.blackList = unsubscribeService.blackList;
                unsubscribeService.loadBlackList();
                $scope.refreshBlackList = function () {
                    unsubscribeService.loadBlackList(true);
                };
                $scope.setFilter = function () { };
                $scope.contentTypes = $scope.unsubscribeService.contentTypes;
                $scope.datepickers = [{ open: false }, { open: false }];
                $scope.toggleDatepicker = function ($event, index) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    $scope.datepickers[index].open = !$scope.datepickers[index].open;
                };
                $scope.unsubscribedTableHead = {
                    a: {
                        value: 'Timestamp',
                        sortedField: 'modifiedInt'
                    },
                    b: {
                        value: 'Name',
                        sortedField: 'firstName'
                    },
                    c: {
                        value: 'Destinator',
                        sortedField: 'destinator'
                    },
                    d: {
                        value: 'Media',
                        sortedField: 'media'
                    },
                    e: {
                        value: 'Unsubscribed by',
                        sortedField: 'modifiedBy'
                    },
                    f: {
                        value: 'Message Type',
                        sortedField: 'contentType'
                    }
                };
                $scope.sort = {
                    column: 'modifiedInt',
                    descending: true
                };
                $scope.selectedCls = function (column) {
                    var arrowClass = 'glyphicon-chevron-down';
                    if (!$scope.sort.descending) {
                        arrowClass = 'glyphicon-chevron-up';
                    }
                    return column === $scope.sort.column && arrowClass;
                };
                $scope.changeSorting = function (column) {
                    var sort = $scope.sort;
                    if (sort.column === column) {
                        sort.descending = !sort.descending;
                    }
                    else {
                        sort.column = column;
                        sort.descending = false;
                    }
                };
                $scope.setRouteNg2 = function (personid) {
                    // Changing URL as its displaying encoded url in browser
                    $location.url($scope.getUserRouteLink(personid));
                    var params = {};
                    params[$scope.userParam] = personid;
                    eventSharingService.setRoute($scope.userPath, params);
                };
                $scope.getUserRouteLink = function (personId) {
                    return $scope.userPath + '?' + $scope.userParam + '=' + personId;
                };
                scope.isInIframe = window.self !== window.top;
            }
        };
    }]);
//# sourceMappingURL=unsubscribe.directive.js.map